import { useEffect, useState } from 'react'

export const useScrollWithThreshold = (threshold: number, { enabled = true } = {}) => {
  const [isBelowThreshold, setIsBelowThreshold] = useState(false)

  useEffect(() => {
    function onScroll() {
      if (window.scrollY >= threshold) {
        setIsBelowThreshold(true)
      } else {
        setIsBelowThreshold(false)
      }
    }
    if (enabled) {
      document.addEventListener('scroll', onScroll)

      return () => document.removeEventListener('scroll', onScroll)
    }
  }, [threshold, enabled])
  return isBelowThreshold
}
